import React, { useEffect, useRef, useState } from "react";
import {
  IoIosArrowDropright,
  IoIosArrowDropdown,
  IoIosArrowUp,
  IoIosArrowDown,
  IoIosArrowDropup,
} from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { useStores } from "../../store";
import {
  MdDownload,
  MdOutlineRecordVoiceOver,
  MdOutlineVoiceOverOff,
  MdRefresh,
} from "react-icons/md";
import {
  AiFillPlayCircle,
  AiFillWarning,
  AiOutlineCheck,
  AiOutlineClose,
} from "react-icons/ai";
import MailForRemindCandidate from "./MailForRemindCandidate";
import { getDomainForWhiteLabeling } from "../../services/white_label";
import { apiPostPut } from "../../api/api_methods";
import Loader from "../reusble_components/loader";
import { Observer } from "mobx-react";
import Remainder from "../reusble_components/popup/Remainder";
import MailPopup from "./MailPopup";
import MailPopUp2 from "./MailPopUp2";
import ReportVoiceOver from "./reportVoiceOver";

const ReportCard = (
  {
    title,
    score,
    details,
    questions,
    reportId,
    technical,
    recruiterId,
    Suggestions,
    hr,
    mcq,
    Summary,
    videoData,
    candidate,
    show,
    commingFrom = "companySide",
    userCompleteAssessment,
    enable = true,
    details2,
    video,
    salarySuggetionTemp,
    interviewId = null,
    summerySuggestion,
    interviewSuggestion,
    isJobPost,
    applicantId,
    meetingId,
    handleButtonClick,
  },
  anyTestFailed = true
) => {
  const { RecuiterStore, PopupStore } = useStores();
  const [isExpanded, setIsExpanded] = useState(false);
  const [expandedQuestion, setExpandedQuestion] = useState(null);
  const [isVoiceOn, setIsVoiceOn] = useState(false);
  const navigate = useNavigate();
  const [isVideoVisible, setIsVideoVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [thumbnail, setThumbnail] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // const applicantId = queryParams.get("applicant");
  const [isVoiceOverOpen, setIsVoiceOverOpen] = useState(false);
  const [selectedTestCases, setSelectedTestCases] = useState({});

  // Debug logging for score
  useEffect(() => {
    console.log('ReportCard score prop:', { score, type: typeof score, isNull: score === null, isUndefined: score === undefined, isEmpty: score === "" });
  }, [score]);

  // Helper function to parse score
  const parseScore = (scoreValue) => {
    if (scoreValue === "Pending") return "Pending";
    if (scoreValue === null || scoreValue === undefined || scoreValue === "") return 0;
    
    if (typeof scoreValue === 'number' && !isNaN(scoreValue)) {
      return scoreValue;
    } else if (typeof scoreValue === 'string') {
      const parsed = parseFloat(scoreValue);
      return !isNaN(parsed) ? parsed : 0;
    } else {
      return Number(scoreValue) || 0;
    }
  };

  const toggleQuestion = (index) => {
    if (expandedQuestion === index) {
      setExpandedQuestion(null);
    } else {
      setExpandedQuestion(index);
    }
  };

  const technicalReportNavigation = () => {
    if (RecuiterStore.jobPostApplicant?.technicalInterview) {
      navigate(`/company/report/${reportId}`);
    } else {
      alert("technical interview is not completed by applicant");
    }
  };

  const hrReportNavigation = () => {
    if (RecuiterStore.jobPostApplicant?.hrInterview) {
      navigate(`/company/report/${reportId}`);
    } else {
      alert("HR interview is not completed by applicant");
    }
  };
  const mcqReportNavigation = () => {
    if (RecuiterStore.jobPostApplicant?.mockTest) {
      navigate(`/dashboard/mockexamreport?id=${reportId}`);
    } else {
      alert("MCQ is not completed by applicant");
    }
  };

  useEffect(() => {
    const captureThumbnail = () => {
      const video = videoRef.current;
      const canvas = canvasRef.current;
      const ctx = canvas?.getContext("2d");

      video.currentTime = 2; // Capture at the 2-second mark

      video.onseeked = () => {
        canvas.width = 200;
        canvas.height = 100;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        setThumbnail(canvas.toDataURL("image/png")); // Convert to base64
      };
    };

    console.log(isJobPost, "isJobPost");

    // console.log("videoData", thumbnail);

    const video = videoRef.current;
    if (video) {
      video.addEventListener("loadeddata", captureThumbnail);
      return () => video.removeEventListener("loadeddata", captureThumbnail);
    }
    console.log("videoData", videoData);
  }, []);

  const downloadRecordedVideoFromStorage = () => {
    const link = videoData?.videoSrc;
    if (link) {
      window.open(link, "_blank");
    } else {
      alert("Video not found in the storage");
    }
  };
  const [mail, setMail] = useState(false);
  const [mailReminder, setMailReminder] = useState(false);
  const [sub, setSub] = useState("");
  const [content, setContent] = useState("");
  const navigateToInterview = (interviewId, applicantId) => {
    localStorage.setItem("location", window.location.pathname);
    const baseUrl =
      getDomainForWhiteLabeling() === "app.reaidy.io"
        ? "https://user.reaidy.io"
        : getDomainForWhiteLabeling();
    const url = `https://${baseUrl.replace("https://", "")}/interview-invitation?meetingid=${interviewId}&applicationId=${applicantId}`;

    return url;
    // window.location.href = url;
  };
  const navigateToMockTest = (invitationId, applicantId) => {
    // alert("hello");
    const baseUrl =
      getDomainForWhiteLabeling() === "app.reaidy.io"
        ? "https://user.reaidy.io"
        : getDomainForWhiteLabeling();
    const url =baseUrl === "app.reaidy.io" ? `https://user.reaidy.io/mcq-test/${invitationId}` : `https://${baseUrl.replace("https://", "")}/dashboard/mocktest?mocktestId=${invitationId}&applicationId=${applicantId}&recruiterId=${recruiterId}`;
    return url;
    // window.location.href = url;
  };

  const user = JSON.parse(localStorage.getItem("user"));
  const subject = `Action Required: Start Your Assessment for ${
    candidate?.jobRole || "[the position]"
  } at ${user?.companyName || "[Company Name]"}`;
  const message = `
Dear ${candidate?.name},

Thank you for applying for the ${
    candidate?.jobRole ? candidate?.jobRole : "[the position]"
  } at ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  } has been successful. We were highly impressed with your experience and qualifications, and we are excited to welcome you to our team.

What's Next?
Our HR team will be reaching out to you shortly to discuss the next steps, including the onboarding process, your start date, and any other necessary details. Please keep an eye on your email for further instructions.

About ${JSON.parse(localStorage.getItem("user"))?.companyName}:
At ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  }, we are passionate about [briefly describe what your company does, its mission, or values]. We believe that your skills and experience will be a valuable addition to our team, and we are excited to see the contributions you will make.

Contact Information:
If you have any questions in the meantime, please feel free to reach out to us at ${
    JSON.parse(localStorage.getItem("user"))?.mail
  } or contact us at ${JSON.parse(localStorage.getItem("user"))?.mobile}.
We appreciate your interest in joining ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  } and look forward to seeing your completed assessment.

Best regards,
${JSON.parse(localStorage.getItem("user"))?.name},
${JSON.parse(localStorage.getItem("user"))?.companyName}

`;

  const hitResultAPI = async (regenerate) => {
    setLoader(true);
    // RecuiterStore.setLoader(true);
    console.log(regenerate);
    const body = {
      interviewId: interviewId ?? reportId,
      regenerate: regenerate ?? null,
    };
    try {
      let newBody = body;
      newBody = {
        ...newBody,
      };
      const res = await apiPostPut(newBody, `/interview/result`, "POST");
      console.log("res", res);
      if (res.status === 200) {
        alert("Result generated successfully");
        RecuiterStore.fetchApplicantDetails(applicantId);
      } else {
        alert(res.body.message);
      }
    } catch (error) {
      console.log(error);
      alert("Failed to generate result. Please try again.");
    } finally {
      setLoader(false);
      // RecuiterStore.setLoader(false);
    }
  };

  function generateAssessmentMessage(assessments) {
    const user = JSON.parse(localStorage.getItem("user"));

    const assessmentLinks = assessments
      .map(
        (assessment, index) =>
          `        ${index + 1}. ${assessment.name}: ${assessment.link}`
      )
      .join("\n");

    return `
  Dear ${candidate?.name},

  Thank you for applying for the ${
    candidate?.jobRole ? candidate?.jobRole : "[the position]"
  } at ${
      user?.companyName ? user?.companyName : "[Company Name]"
    }. We noticed that you have not yet started the required assessment(s), which are an essential part of the application process.

  To proceed with your application, please follow the steps below to begin your assessment(s):

     
    Next Steps:

      Assessment links:
${assessmentLinks}

                            ------ OR ------

        1. Go to ${
          getDomainForWhiteLabeling() === "app.reaidy.io"
            ? "https://user.reaidy.io"
            : getDomainForWhiteLabeling()
        }.
        2. Navigate to the Activities section.
        3. Select the ${
          candidate?.jobRole ? candidate?.jobRole : "[the position]"
        } you applied for.
        4. Start your Assessment(s).

  Please make sure to begin the assessment(s) by ${new Date().toLocaleDateString()} to continue being considered for the position.

  If you need any assistance or have questions, feel free to reach out to us at ${
    user?.mail
  } or contact us at ${user?.mobile}.

  We appreciate your interest in joining ${
    user?.companyName ? user?.companyName : "[Company Name]"
  } and look forward to seeing your completed assessment(s).

  Best regards,

  ${user?.name}
  ${user?.designation ? user?.designation : "[Your Designation]"}
  ${user?.companyName}
  `;
  }

  const getOptionsForRemainder = () => {
    const opt = [];
    if (
      RecuiterStore.jobPostApplicant?.jobPostId?.mockTest !== null &&
      RecuiterStore.jobPostApplicant?.jobPostId?.mockTest &&
      !RecuiterStore.jobPostApplicant?.mockTest
    ) {
      opt.push({
        name: "MCQ",
        link: navigateToMockTest(
          RecuiterStore.jobPostApplicant?.jobPostId?.mockTest?._id,
          RecuiterStore.jobPostApplicant?._id
        ),
      });
    }
    if (
      RecuiterStore.jobPostApplicant?.jobPostId?.technicalInterview !== null ||
      (RecuiterStore.jobPostApplicant?.jobPostId?.technicalInterview &&
        RecuiterStore.jobPostApplicant?.technicalInterview
          ?.isInterviewCompleted === false)
    ) {
      opt.push({
        name: "Technical Interview",
        link: navigateToInterview(
          RecuiterStore.jobPostApplicant?.jobPostId?.technicalInterview?._id,
          RecuiterStore.jobPostApplicant?._id
        ),
      });
    }
    if (
      RecuiterStore.jobPostApplicant?.jobPostId?.hrInterview !== null ||
      (RecuiterStore.jobPostApplicant?.jobPostId?.hrInterview &&
        RecuiterStore.jobPostApplicant?.hrInterview?.isInterviewCompleted ===
          false)
    ) {
      opt.push({
        name: "HR Interview",
        link: navigateToInterview(
          RecuiterStore.jobPostApplicant?.jobPostId?.hrInterview?._id,
          RecuiterStore.jobPostApplicant?._id
        ),
      });
    }
    return opt;
  };

  const message1 = generateAssessmentMessage(RecuiterStore.RemaindedAssessment);

  const [lastPeriodIndex, setLastPeriodIndex] = useState(null);
  useEffect(() => {
    if (typeof questions === "string") {
      const index = questions.lastIndexOf(".");

      setLastPeriodIndex(index);
    } else {
      setLastPeriodIndex(-1);
      console.warn(
        "ReportCard: 'questions' prop is not a string or is missing."
      );
    }
  }, [questions]);
  let displayNumber = "...";
  if (lastPeriodIndex !== null) {
    if (lastPeriodIndex !== -1) {
      displayNumber = lastPeriodIndex + 1;
    }
  }

  const selectTestCase = (questionId, testIdx) => {
    setSelectedTestCases((prev) => ({ ...prev, [questionId]: testIdx }));
  };

  return (
    <Observer>
      {() => (
        <div
          className={`px-2 md:px-0 py-6 w-full ${
            title !== "Interview Report"
              ? "border-b-2  border-dashed border-gray-300"
              : ""
          }`}
        >
          {/* <button
            onClick={() => {
              setLoader(!loader);
            }}
            className="bg-primary rounded-xl border px-4 py-2 flex items-center gap-2 text-white"
          >
            Genarate Results
            <MdRefresh className="text-white" />
          </button> */}

          <Remainder
            options={getOptionsForRemainder()}
            onSent={() => {
              const mess = generateAssessmentMessage(
                RecuiterStore.RemaindedAssessment
              );
              setSub(subject);
              setContent(mess);
              PopupStore.setMail2(true);
            }}
          />

          {!show ? (
            <div className="flex justify-between items-end">
              <div className="w-full">
                <h3 className="text-lg gil-med">
                  {title}{" "}
                  <sup className="md:text-[9px] opacity-50">
                    {title.includes("Salary") ? "BETA" : ""}
                  </sup>
                </h3>
                <div className="flex items-center w-full justify-between">
                  <div className="flex  mt-3 items-center  space-x-2 md:mb-0 mb-10 ">
                    <AiFillWarning className="text-yellow text-2xl" />
                    <span className="ml-6  text-yellow gil-med">
                      {title.includes("Salary Recommendation System")
                        ? "Salary Suggetion is not Generated"
                        : "This section not included in this Job post"}
                    </span>
                  </div>
                  {/* <button
                className="bg-primary rounded-xl border px-4 py-2 flex items-center gap-2 text-white"
                onClick={() => {
                  setMail(true);
                  setSub(subject);
                  setContent(message);
                  PopupStore.setMail(true);
                }}
              >
                Remind candidate
                <IoIosArrowDropright className="text-white" />
              </button> */}
                </div>
              </div>
            </div>
          ) : (score !== null && score !== "" && score !== undefined) ? (
            <>
              <div className="flex justify-between items-center w-full">
                <div className="flex flex-col w-full">
                  <div className="flex w-full items-center justify-between">
                    <h3 className="text-lg gil-med">
                      {title}{" "}
                      <sup className="md:text-[9px] opacity-50">
                        {title.includes("Salary") ? "BETA" : ""}
                      </sup>
                    </h3>
                    {/* {score && (
                    <span className="text-2xl text-[#20BF55] font-bold ml-2 md:ml-6">
                      {parseFloat(score).toFixed(0)}%
                    </span>
                  )} */}

                    <div className="md:flex gap-5 lg:flex  hidden">
                      {title !== "MCQ Test Report" || title !== "Coding Interview Report" && (
                        <button
                          className="text-primary group flex items-center text-base hover:underline "
                          onClick={() => {
                            hitResultAPI(true);
                          }}
                        >
                          <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out">
                            Regenerate report
                          </span>
                          {loader ? (
                            <MdRefresh className="ml-1 animate-spin" />
                          ) : (
                            <MdRefresh className="ml-1" />
                          )}
                        </button>
                      )}
                      {/* <button
                        className="text-primary group flex items-center text-base"
                        onClick={() => setIsVoiceOverOpen(true)}
                      >
                        {isVoiceOn ? (
                          <MdOutlineVoiceOverOff className="text-primary" />
                        ) : (
                          <MdOutlineRecordVoiceOver className="text-primary" />
                        )}
                      </button> */}
                      <button
                        onClick={() => {
                          setIsExpanded(!isExpanded);
                          console.log("expanded", questions);
                        }}
                        className="text-primary text-base hover:underline flex"
                      >
                        {isExpanded ? "view less" : "view more"}{" "}
                        {isExpanded ? (
                          <IoIosArrowDropup className="mt-1" />
                        ) : (
                          <IoIosArrowDropdown className="mt-1" />
                        )}
                      </button>
                    </div>
                  </div>
                  {summerySuggestion && (
                    <div className="flex w-full md:mt-4 tc1:mt-1 tc1:mb-1 md:mb-0 flex-col ">
                      {/* <h1 className="text-lg gil-med ">Interview Summary :</h1> */}
                      <p className="text-base">{summerySuggestion}</p>
                    </div>
                  )}

                  <div
                    className={`flex w-full items-center ${
                      video ? "justify-between" : "justify-start"
                    }`}
                  >
                    <div
                      className={` grid md:grid-cols-2 lg:grid-cols-2 md:gap-x-4 md:gap-y-2 ${
                        video
                          ? "md:grid-cols-2 lg:grid-cols-2 md:gap-x-4 md:gap-y-2 w-[32vw]"
                          : "md:grid-cols-3 lg:grid-cols-2 md:gap-x-0 md:gap-y-2 w-[50vw]"
                      }`}
                    >
                      {details?.slice(0, 4)?.map((detail, index) => (
                        <div key={index} className="flex my-1 md:my-3 mx-2">
                          <span className="border-l-2 border-primary text-[#747474] f</div>ont-medium pl-2 whitespace-nowrap">
                            {detail.label?.includes("Recommended") ? (
                              <p className="text-primary font-semibold">
                                {detail.label}
                              </p>
                            ) : (
                              detail.label
                            )}
                          </span>
                          <span
                            className={` ml-1 whitespace-nowrap 
                          ${
                            details.value === "Failed"
                              ? "!text-red-500"
                              : details.value === "Qualified"
                              ? "!text-green-500"
                              : "text-black"
                          } `}
                          >
                            {detail.value === "Failed" ? (
                              <p className="text-red-500">{detail.value}</p>
                            ) : detail.value === "Qualified" ? (
                              <p className="text-green-500">{detail.value}</p>
                            ) : (
                              <>
                                {detail.label?.includes("Recommended") ? (
                                  <p className="text-black font-semibold">
                                    {detail.value}
                                  </p>
                                ) : (
                                  detail.value
                                )}
                              </>
                            )}
                          </span>
                        </div>
                      ))}
                    </div>
                    {video && (
                      <>
                        <div className=" flex justify-center items-center hidden md:block lg:block">
                          {videoData === null ? (
                            ""
                          ) : videoData?.videoSrc === "" &&
                            videoData?.image !== "" ? (
                            <div
                              className="flex justify-center text-center bg-[#e9e9e9] cursor-pointer w-[200px] h-[100px] items-center m-3 rounded-lg  whitespace-nowrap "
                              onClick={() => setIsVideoVisible(true)}
                            >
                              <img
                                src={videoData?.image}
                                alt="video"
                                className="w-full h-full max-h-[400px] object-cover rounded-lg"
                              />
                            </div>
                          ) : videoData?.videoSrc === "" ? (
                            <div className="flex relative justify-center text-center bg-[#e9e9e9] w-[200px] h-[100px]  m-3 rounded-lg  whitespace-nowrap ">
                              <button
                                // onClick={() => setIsVideoVisible(true)}
                                className="flex absolute cursor-auto flex-row top-8 items-center text-sm mt-1 bg-[#e9e9e9]  rounded focus:outline-none"
                              >
                                No Video Available
                              </button>
                            </div>
                          ) : (
                            <div className="flex relative justify-center text-center bg-[#e9e9e9] w-[200px] h-[100px]  m-3 rounded-lg  whitespace-nowrap ">
                              <button
                                onClick={() => setIsVideoVisible(true)}
                                className="flex absolute flex-row top-8 items-center text-sm mt-1 bg-[#e9e9e9] text-primary border-2 px-4 py-1 border-primary hover:border-2 hover:border-primary hover:text-primary font-bold rounded focus:outline-none"
                              >
                                <AiFillPlayCircle className="mr-2" /> Play Video
                              </button>
                              <video
                                ref={videoRef}
                                src={videoData?.videoSrc}
                                style={{ display: "none" }}
                                crossOrigin="anonymous"
                              />
                              <canvas
                                ref={canvasRef}
                                style={{ display: "none" }}
                              />
                              {videoData?.image && (
                                <img
                                  src={videoData?.image}
                                  alt="Video Thumbnail"
                                  className="w-full h-full max-h-[400px] object-cover rounded-lg"
                                />
                              )}
                              {/* <video
                        src={videoData?.videoSrc}
                        type="video/webm"
                        className="w-full"
                        controls
                      />
                      <button
                        onClick={downloadRecordedVideoFromStorage}
                        className="flex flex-row items-center text-sm mt-1 text-primary border-2 border-white hover:border-2 hover:border-primary hover:bg-transparent hover:text-primary font-bold py-2 px-4 rounded focus:outline-none"
                      >
                        <MdDownload className="mr-2" /> Download
                      </button> */}
                            </div>
                          )}
                        </div>
                        <div className="text-center md:ml-5 md:mt-2 mt-5">
                          <div className="relative md:w-20 md:h-20  sm:w-20 sm:h-20 w-[4.2rem] h-[4.2rem] mx-auto">
                            <svg
                              className="absolute top-0 left-0 w-full h-full"
                              viewBox="0 0 100 100"
                            >
                              <circle
                                cx="50"
                                cy="50"
                                r="45"
                                className="stroke-current text-gray-200"
                                strokeWidth="10"
                                fill="none"
                              />
                              <circle
                                cx="50"
                                cy="50"
                                r="45"
                                className="stroke-current text-primary"
                                strokeWidth="10"
                                fill="none"
                                strokeDasharray="282.6"
                                strokeDashoffset={
                                  score === "Pending"
                                    ? 282.6 // If overallScore is "Pending", treat as 0% (full circle)
                                    : 282.6 -
                                      (282.6 *
                                        (() => {
                                          const parsedScore = parseScore(score);
                                          console.log('StrokeDashoffset debugging:', { score, parsedScore, type: typeof score });
                                          return typeof parsedScore === 'number' ? parsedScore : 0;
                                        })()) /
                                        100
                                }
                                strokeLinecap="round"
                                transform="rotate(-90, 50, 50)"
                              />
                            </svg>
                            <div className="absolute inset-0 flex items-center justify-center text-primary">
                              <span
                                className={`font-semibold ${
                                  score === "Pending"
                                    ? "text-md"
                                    : "md:text-lg text-base"
                                }`}
                              >
                                {(() => {
                                  const parsedScore = parseScore(score);
                                  console.log('Score debugging:', { score, parsedScore, type: typeof score });
                                  return parsedScore === "Pending" ? "Pending" : parsedScore.toFixed(0) + "%";
                                })()}
                              </span>
                            </div>
                          </div>
                          <p className="mt-2 font-medium text-[#000000] whitespace-nowrap text-sm">
                            Overall score
                          </p>
                        </div>
                      </>
                    )}
                  </div>

                  {video && (
                    <div className=" flex justify-center items-center md:hidden lg:hidden">
                      {videoData === null ? (
                        ""
                      ) : videoData?.videoSrc === "" ? (
                        <div
                          className="flex justify-center text-center bg-[#e9e9e9] cursor-pointer w-[200px] h-[100px] items-center m-3 rounded-lg  whitespace-nowrap "
                          onClick={() => setIsVideoVisible(true)}
                        >
                          <img
                            src={videoData?.image}
                            alt="video"
                            className="w-full h-full object-cover rounded-lg"
                          />
                        </div>
                      ) : (
                        <div className="flex relative justify-center text-center bg-[#e9e9e9] w-[200px] h-[100px]  m-3 rounded-lg  whitespace-nowrap ">
                          <button
                            onClick={() => setIsVideoVisible(true)}
                            className="flex absolute flex-row top-8 items-center text-sm mt-1 bg-[#e9e9e9] text-primary border-2 px-4 py-1 border-primary hover:border-2 hover:border-primary hover:text-primary font-bold rounded focus:outline-none"
                          >
                            <AiFillPlayCircle className="mr-2" /> Play Video
                          </button>
                          <video
                            ref={videoRef}
                            src={videoData?.videoSrc}
                            style={{ display: "none" }}
                            crossOrigin="anonymous"
                          />
                          <canvas ref={canvasRef} style={{ display: "none" }} />
                          {videoData?.image && (
                            <img
                              src={videoData?.image}
                              alt="Video Thumbnail"
                              className="w-full h-full max-h-[400px] object-cover rounded-lg"
                            />
                          )}
                          {/* <video
                        src={videoData?.videoSrc}
                        type="video/webm"
                        className="w-full"
                        controls
                      />
                      <button
                        onClick={downloadRecordedVideoFromStorage}
                        className="flex flex-row items-center text-sm mt-1 text-primary border-2over:border-2 hover:border-primary hover:bg-transparent hover:text-primary font-bold py-2 px-4 rounded focus:outline-none"
                      > border-white h
                        <MdDownload className="mr-2" /> Download
                      </button> */}
                        </div>
                      )}
                    </div>
                  )}

                  <div className="block  md:hidden mx-3">
                    <button
                      onClick={() => {
                        setIsExpanded(!isExpanded);
                        console.log("expanded", questions);
                      }}
                      className="text-primary text-base hover:underline flex"
                    >
                      {isExpanded ? "view less" : "view more"}{" "}
                      {isExpanded ? (
                        <IoIosArrowDropdown className="mt-1" />
                      ) : (
                        <IoIosArrowDropright className="mt-1" />
                      )}
                    </button>
                  </div>
                </div>
              </div>
              {isVideoVisible && (
                <div
                  // onClick={() => setIsVideoVisible(false)}
                  className="fixed w-screen pt-40 h-[105vh] z-[51] top-0 left-0 backdrop-filter backdrop-blur-sm bg-black overflow-hidden bg-opacity-40 "
                >
                  {videoData?.videoSrc === "" ? (
                    <div
                      className=" bg-white p-5"
                      style={{ maxWidth: "640px", margin: "20px auto" }}
                    >
                      <div className="flex justify-center text-center bg-[#e9e9e9] h-auto items-center m-3 rounded-lg  whitespace-nowrap ">
                        <img
                          src={videoData?.image}
                          alt="video"
                          className="w-full h-full max-h-[400px] object-cover rounded-lg"
                        />
                      </div>
                      <button
                        onClick={() => setIsVideoVisible(false)}
                        className=" text-primary font-bold py-1 px-2 rounded"
                      >
                        Close
                      </button>
                    </div>
                  ) : (
                    <div
                      className=" bg-white p-5"
                      style={{ maxWidth: "640px", margin: "20px auto" }}
                    >
                      <video
                        src={videoData?.videoSrc}
                        type="video/webm"
                        className="w-full"
                        controls
                      />
                      <div className="flex justify-between items-center mt-2">
                        <button
                          onClick={downloadRecordedVideoFromStorage}
                          className="flex flex-row items-center text-sm mt-1 text-primary border-2 border-white hover:border-2 hover:border-primary hover:text-primary font-bold py-2 px-4 rounded focus:outline-none"
                        >
                          <MdDownload className="mr-2" /> Download
                        </button>
                        <button
                          onClick={() => setIsVideoVisible(false)}
                          className=" text-primary font-bold py-1 px-2 rounded"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* {interviewSuggestion && isJobPost === false && (
                <div className="flex w-full mt-4 flex-col px-3">
                  <h1 className="md:text-lg tc1:text-sm gil-med text-black mb-3 ">
                    Interview Suggestions for candidate :
                  </h1>
                  <ul className="text-base">
                    {interviewSuggestion
                      ?.split("\n")
                      .filter((item) => item)
                      .map((suggestion, index) => (
                        <p className="py-1 tc1:text-xs md:text-sm" key={index}>
                          {suggestion}
                        </p>
                      ))}
                  </ul>
                </div>
              )} */}
              {isExpanded && (
                <div className="text-sm text-gray-700">
                  <div className="grid grid-cols-2 md:w-[65%] sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-3 gap-x-0 gap-y-2">
                    {details?.slice(4)?.map((detail, index) => (
                      <div key={index} className="flex my-3 ml-2">
                        <span className="border-l-2 border-primary pl-2">
                          {detail.label}{" "}
                        </span>
                        <span className="text-primary ml-1">
                          {detail.value}
                        </span>
                      </div>
                    ))}
                  </div>
                  {salarySuggetionTemp && (
                    <div className="mb-3">
                      <h4 className="text-base font-semibold my-2">
                        Recommendation based below metrics :
                      </h4>
                      <ul className="">
                        {salarySuggetionTemp?.keyMetrics.positives?.map(
                          (positive, index) => (
                            <li
                              key={index}
                              className="flex mb-2 items-center gap-2 text-green-500 font-semibold"
                            >
                              <AiOutlineCheck className="text-xl " /> {positive}
                            </li>
                          )
                        )}
                      </ul>
                      {/* <h4 className="font-semibold mt-2">Negatives:</h4> */}
                      <ul className="">
                        {salarySuggetionTemp?.keyMetrics.negatives?.map(
                          (negative, index) => (
                            <li
                              key={index}
                              className="flex mb-2 items-center gap-2 text-red-500 font-semibold"
                            >
                              <AiOutlineClose className="text-xl" /> {negative}
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  )}
                  {questions && (
                    <div className="mt-4 w-full px-3">
                      {questions?.map((question, index) => (
                        <div
                          key={index}
                          className={`mt-2 w-full py-3 ${
                            index !== questions.length - 1
                              ? "border-b-2 border-[#F2F2F2]"
                              : ""
                          }`}
                        >
                          <div className="flex justify-between items-center">
                            <p className="flex w-full justify-between items-start gap-2">
                              <div className=" flex font-light text-gray-800">
                                {index + 1}
                                {". "}
                                {/* {question?.question}{" "} */}
                                {/* {typeof question?.question === "string" ? (
                                  <span style={{ backgroundColor: "yellow" }}>
                                    {question?.question}
                                  </span>
                                ) : (
                                  "Invalid question data"
                                )} */}
                                {/* {(() => {
                                  const text = question?.question;
                                  if (typeof text === "string") {
                                    const localLastPeriodIndex =
                                      text.lastIndexOf(".");

                                    if (
                                      localLastPeriodIndex !== -1 &&
                                      localLastPeriodIndex < text.length - 1
                                    ) {
                                      const beforePeriod = text.substring(
                                        0,
                                        localLastPeriodIndex + 1
                                      );
                                      const afterPeriod = text.substring(
                                        localLastPeriodIndex + 1
                                      );

                                      return (
                                        <>
                                          {beforePeriod}
                                          <span
                                            style={{
                                              backgroundColor: "yellow",
                                            }}
                                          >
                                            {afterPeriod}
                                          </span>
                                        </>
                                      );
                                    } else {
                                      return text;
                                    }
                                  }
                                  return "Invalid question data";
                                })()} */}

                                {(() => {
                                  const text =
                                    question?.question ||
                                    question?.questionId?.question;

                                  if (typeof text !== "string") {
                                    return "Invalid question data";
                                  }

                                  let validPeriodIndex = -1;
                                  let searchFromIndex = text.length - 1;

                                  while (true) {
                                    let potentialIndex = text.lastIndexOf(
                                      ".",
                                      searchFromIndex
                                    );

                                    if (potentialIndex === -1) {
                                      break;
                                    }

                                    if (
                                      potentialIndex < text.length - 1 &&
                                      text[potentialIndex + 1] === " "
                                    ) {
                                      validPeriodIndex = potentialIndex;
                                      break;
                                    } else {
                                      searchFromIndex = potentialIndex - 1;

                                      if (searchFromIndex < 0) {
                                        break;
                                      }
                                    }
                                  }

                                  // if (validPeriodIndex !== -1) {
                                  //   const beforeHighlight = text.substring(
                                  //     0,
                                  //     validPeriodIndex + 1
                                  //   );
                                  //   const afterHighlight = text.substring(
                                  //     validPeriodIndex + 1
                                  //   );

                                  if (
                                    validPeriodIndex !== -1 &&
                                    text.endsWith("?")
                                  ) {
                                    const beforeHighlight = text.substring(
                                      0,
                                      validPeriodIndex + 1 // Include the period itself
                                    );
                                    const afterHighlight = text.substring(
                                      validPeriodIndex + 1 // Start after the period
                                    );

                                    return expandedQuestion === index ? (
                                      <div
                                        className="cursor-pointer"
                                        onClick={() => toggleQuestion(index)}
                                      >
                                        {beforeHighlight}
                                        <span className="text-gray-800 font-semibold">
                                          {afterHighlight}
                                        </span>
                                      </div>
                                    ) : (
                                      <span
                                        className="text-gray-800 font-semibold cursor-pointer"
                                        onClick={() => toggleQuestion(index)}
                                      >
                                        {afterHighlight}
                                      </span>
                                    );
                                  } else {
                                    return (
                                      <div
                                        className="cursor-pointer"
                                        onClick={() => toggleQuestion(index)}
                                      >
                                        {text}
                                      </div>
                                    );
                                  }
                                })()}
                              </div>
                              <div className="flex gap-2 justify-between items-center">
                                {enable && (
                                  <div className="lg:justify-end">
                                    <span className="text-primary ml-3 justify-end lg:ml-0">
                                      Score:{question?.score}
                                    </span>
                                  </div>
                                )}

                                <button
                                  onClick={() => toggleQuestion(index)}
                                  className="text-sm hover:underline"
                                >
                                  {expandedQuestion === index ? (
                                    <IoIosArrowUp />
                                  ) : (
                                    <IoIosArrowDown />
                                  )}
                                </button>
                              </div>
                            </p>
                          </div>
                          {expandedQuestion === index && (
                            <div className="mt-2 p-2 text-[#7F7F7F]">
                              {/* Test Cases Section */}
                              {((question.answer && question.answer !== "") && (question?.testCases && question?.testCases.length > 0)) ? (
                                <div>
                                 <textarea
                                 value={(() => {
                                   try {
                                     const answer =
                                       question.answer ||
                                       question.userAnswer;
                                     if (!answer) return "";
                                     return typeof answer === "string"
                                       ? JSON.parse(answer)
                                       : answer;
                                   } catch (error) {
                                     // If JSON parsing fails, return the raw value
                                     return (
                                       question.answer ||
                                       question.userAnswer ||
                                       ""
                                     );
                                   }
                                 })()}
                                 readOnly
                                 placeholder="No answer provided"
                                 className="min-h-[200px] resize-none bg-black text-white w-full rounded-lg p-4 font-mono"
                               />
                                <div className="space-y-2 mt-2">
                                  <label className="text-sm font-medium text-gray-700">
                                    Test Cases ({question.testCasesPassed || 0}/
                                    {question?.testCases?.filter((testCase) => testCase.isVerified).length || 0} Passed)
                                  </label>
                                  <div className="flex flex-col lg:flex-row gap-4">
                                    {/* Test Cases List */}
                                    <div className="flex-1 min-h-[220px] max-h-[340px] overflow-y-auto bg-white rounded-lg border p-3">
                                      <h4 className="text-sm font-medium text-gray-600 mb-3">
                                        Test Cases List
                                      </h4>
                                      <div className="grid grid-cols-2 gap-2">
                                        {question?.testCases.filter((testCase) => testCase.isVerified).map((testCase, testIdx) => {
                                          const userTestResult = question.testCases?.find(
                                            (ut) => ut.input === testCase.input && ut.expectedOutput === testCase.expectedOutput
                                          );
                                          const isPassed = userTestResult?.isPassed || false;
                                          const isSelected = selectedTestCases[question._id] === testIdx;
                                          return (
                                            <div
                                              key={testIdx}
                                              onClick={() => selectTestCase(question._id, testIdx)}
                                              className={`p-3 rounded-lg border cursor-pointer transition-colors text-sm flex flex-col gap-1 ${
                                                isSelected
                                                  ? "border-blue-500 bg-blue-50"
                                                  : isPassed
                                                  ? "border-green-200 bg-green-50 hover:bg-green-100"
                                                  : "border-red-200 bg-red-50 hover:bg-red-100"
                                              }`}
                                            >
                                              <div className="flex items-center justify-between">
                                                <div className="flex items-center gap-2">
                                                  <span className="font-medium">Test Case {testIdx + 1}</span>
                                                  <span className={`text-xs px-2 py-1 rounded ${isPassed ? "bg-green-100 text-green-800 border-green-200" : "bg-red-100 text-red-800 border-red-200"}`}>
                                                    {isPassed ? "Passed" : "Failed"}
                                                  </span>
                                                </div>
                                                {isSelected && <div className="w-2 h-2 bg-blue-500 rounded-full"></div>}
                                              </div>
                                              {testCase.description && (
                                                <p className="text-xs text-gray-600 truncate">{testCase.description}</p>
                                              )}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                    {/* Test Case Details */}
                                    <div className="flex-1 min-h-[340px] max-h-[340px] overflow-y-auto bg-white rounded-lg border p-3">
                                      <h4 className="text-sm font-medium text-gray-600 mb-3">Test Case Details</h4>
                                      {selectedTestCases[question._id] !== undefined ? (
                                        (() => {
                                          const selectedIdx = selectedTestCases[question._id];
                                          const testCase = question?.testCases[selectedIdx];
                                          const userTestResult = question.testCases?.find(
                                            (ut) => ut.input === testCase.input && ut.expectedOutput === testCase.expectedOutput
                                          );
                                          const isPassed = userTestResult?.isPassed || false;
                                          const actualOutput = userTestResult?.actualOutput || "Not executed";
                                          return (
                                            <div className={`rounded-lg p-4 h-full ${isPassed ? "bg-green-50" : "bg-red-50"}`}>
                                              <div className="flex items-center justify-between mb-3">
                                                <h5 className="font-medium">Test Case {selectedIdx + 1}</h5>
                                                <span className={`px-2 py-1 rounded text-xs ${isPassed ? "bg-green-100 text-green-800 border-green-200" : "bg-red-100 text-red-800 border-red-200"}`}>
                                                  {isPassed ? "Passed" : "Failed"}
                                                </span>
                                              </div>
                                              <div className="space-y-3">
                                                <div>
                                                  <span className="text-sm font-medium text-gray-700">Input:</span>
                                                  <div className="bg-white p-3 rounded border mt-1 font-mono text-sm break-all">{testCase.input || "N/A"}</div>
                                                </div>
                                                <div>
                                                  <span className="text-sm font-medium text-gray-700">Expected Output:</span>
                                                  <div className="bg-white p-3 rounded border mt-1 font-mono text-sm break-all">{testCase.expectedOutput || "N/A"}</div>
                                                </div>
                                                  <div>
                                                    <span className="text-sm font-medium text-gray-700">Actual Output:</span>
                                                    <div className={`bg-white p-3 rounded border mt-1 font-mono text-sm break-all ${isPassed ? "text-green-600" : "text-red-600"}`}>{actualOutput}</div>
                                                  </div>
                                                {testCase.description && (
                                                  <div>
                                                    <span className="text-sm font-medium text-gray-700">Description:</span>
                                                    <p className="text-sm text-gray-600 mt-1">{testCase.description}</p>
                                                  </div>
                                                )}
                                                {userTestResult?.executionTime && (
                                                  <div>
                                                    <span className="text-sm font-medium text-gray-700">Execution Time:</span>
                                                    <p className="text-sm text-gray-600 mt-1">{userTestResult.executionTime}ms</p>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        })()
                                      ) : (
                                        <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center h-full flex items-center justify-center">
                                          <p className="text-gray-500 text-sm">Select a test case from the list to view details</p>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                </div>
                              ) : (
                                // fallback for non-coding or non-testcase questions
                                <div className="mt-2">
                                  {question?.answer}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                  {interviewSuggestion && (
                    <div className="flex w-full mt-4 flex-col px-3">
                      <h1 className="md:text-lg tc1:text-sm gil-med text-black mb-3 ">
                        Interview Suggestions for candidate :
                      </h1>
                      <ul className="text-base">
                        {interviewSuggestion
                          ?.split("\n")
                          .filter((item) => item)
                          .map((suggestion, index) => (
                            <p
                              className="py-1 tc1:text-xs md:text-sm"
                              key={index}
                            >
                              {suggestion}
                            </p>
                          ))}
                      </ul>
                    </div>
                  )}
                  {Suggestions && (
                    <div className="mt-4 w-full px-3">
                      {Suggestions?.map((suggestion, index) => (
                        <div
                          key={index}
                          className="mt-2 w-full py-3 border-b-2 border-gray-200"
                        >
                          <div className="flex justify-between items-center">
                            <p className="flex w-full justify-between">
                              <div>{suggestion}</div>
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  {Summary && (
                    <div className="mt-4 w-full px-3">
                      <div className="mt-2 w-full py-3 border-b-2 border-gray-200">
                        <div className="flex justify-between items-center">
                          <p className="flex w-full justify-between">
                            <div>{Summary}</div>
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </>
          ) : (
            <div className="flex justify-between items-start w-full bg-white rounded-lg ">
              <div className="w-full">
                <div className="flex w-full items-center justify-between mb-4">
                  <h3 className="text-xl font-semibold text-gray-800">
                    {title}
                    {title.includes("Salary") && (
                      <sup className="text-xs text-gray-500 ml-1">BETA</sup>
                    )}
                  </h3>
                  {interviewId && (
                    <button
                      onClick={() => hitResultAPI(true)}
                      className="flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-medium"
                    >
                      Generate Results
                      <MdRefresh className="text-xl" />
                    </button>
                  )}
                </div>

                <div className="bg-orange-50 border-l-4 border-orange-400 p-4 rounded-r-lg">
                  <div className="md:flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <AiFillWarning className="text-orange-400 text-2xl flex-shrink-0" />
                      <span className="text-gray-700 font-medium">
                        {interviewId
                          ? "Interview completed, but results have not been generated yet"
                          : "Pending Assessment"}
                      </span>
                    </div>
                    <button
                      className="flex items-center gap-2 mt-2 md:mt-0 text-primary hover:text-primary/80 transition-colors font-medium text-sm"
                      onClick={() => {
                        if (commingFrom === "userSide") {
                          handleButtonClick();
                        } else {
                          // setMail(true);
                          // setSub(subject1);
                          // setContent(message1);
                          // PopupStore.setMail(true);
                          RecuiterStore.RemaindedAssessment = [];
                          PopupStore.setRemainder(true);
                        }
                      }}
                    >
                      {commingFrom === "userSide"
                        ? "Complete the Assessment"
                        : "Send reminder to candidate"}
                      <IoIosArrowDropright className="text-lg" />
                    </button>
                  </div>

                  {!interviewId && (
                    <div className="mt-4 flex flex-col gap-2">
                      <p className="text-sm text-gray-600">
                        The candidate needs to complete this section as part of
                        the assessment process.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          <MailPopUp2
            jobRole={candidate?.jobRole}
            id={candidate?._id}
            interview={true}
            onSent={async () => {
              await RecuiterStore.fetchApplicantDetails(candidate?.id);

              PopupStore.setMail2(false);
            }}
            emails={[candidate?.email]}
            report={mail ? false : true}
            sub={sub}
            mess={content}
            // status={status}
            // statusCondition={statusCondition}
            // statusNumber={statusNumber}
          />
          <ReportVoiceOver
            isOpen={isVoiceOverOpen}
            onClose={() => setIsVoiceOverOpen(false)}
            questions={questions}
          />
        </div>
      )}
    </Observer>
  );
};

export default ReportCard;
